








































import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'
import { ITableConfig } from '@/interfaces'

@Component({
  props: {
    config: {
      type: Object as PropType<ITableConfig>,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    freezeClicked: {
      type: Boolean,
      default: false
    }
  }
})
export default class TableBody extends Vue {
  executeFunctionIfNoTextHighlighted (row: any, index: number) {
    const selection: Selection | null = window.getSelection()
    if (!selection || selection.type !== 'Range') {
      this.$props.config.rowClick(row, index)
      if (this.$props.freezeClicked) {
        const target = this.$refs[`row-${index}`]
        // @ts-ignore
        target[0].classList.add('freeze')
      }
    }
  }
}
